import { useEffect, useLayoutEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiPieChart, FiUsers, FiPackage } from 'react-icons/fi';

const Header = () => {
  const location = useLocation();

  const isActiveCategory = (paths) => paths.some(path => location.pathname.startsWith(path));

  useEffect(() => {
    // Initial icon replacement
    if (window.feather) {
      window.feather.replace();
    }
  }, []);

  // Add useLayoutEffect to handle feather icon replacement on route changes
  useLayoutEffect(() => {
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      if (window.feather) {
        window.feather.replace();
      }
    }, 50);
  }, [location.pathname]);

  const handleNavbarVerticalToggle = (e) => {
    // Fallback toggle mechanism
    const { getItemFromStore, setItemToStore } = window.phoenix?.utils || {
      getItemFromStore: (key, def) => {
        const item = localStorage.getItem(key);
        try {
          return item ? JSON.parse(item) : def;
        } catch {
          return item || def;
        }
      },
      setItemToStore: (key, val) => localStorage.setItem(key, JSON.stringify(val))
    };

    const isCollapsed = document.documentElement.classList.contains('navbar-vertical-collapsed');
    document.documentElement.classList.toggle('navbar-vertical-collapsed');
    setItemToStore('phoenixIsNavbarVerticalCollapsed', !isCollapsed);

    // Dispatch the custom event
    const toggleEvent = new CustomEvent('navbar.vertical.toggle');
    document.dispatchEvent(toggleEvent);
    
    if (e.currentTarget) {
      e.currentTarget.dispatchEvent(new CustomEvent('navbar.vertical.toggle'));
    }
  };

  return (
        <>
            <nav className="navbar navbar-vertical navbar-expand-lg">
                <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
                    {/* scrollbar removed*/}
                    <div className="navbar-vertical-content">
                        <ul className="navbar-nav flex-column" id="navbarVerticalNav">
                            <li className="nav-item">
                                <div className="nav-item-wrapper">
                                    <Link
                                        className={`nav-link label-1 ${location.pathname === '/' ? 'active' : ''}`}
                                        to="/"
                                        role="button"
                                        data-bs-toggle=""
                                        aria-expanded="false"
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="nav-link-icon">
                                                <FiPieChart />
                                            </span>
                                            <span className="nav-link-text-wrapper">
                                                <span className="nav-link-text">Dashboard</span>
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            </li>
                            
                            <li className="nav-item">
                                <div className="nav-item-wrapper">
                                    <Link
                                        className={`nav-link label-1 ${location.pathname === '/clients' ? 'active' : ''}`}
                                        to="/clients"
                                        role="button"
                                        data-bs-toggle=""
                                        aria-expanded="false"
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="nav-link-icon">
                                                <FiUsers />
                                            </span>
                                            <span className="nav-link-text-wrapper">
                                                <span className="nav-link-text">Clients</span>
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            </li>

                            <li className="nav-item">
                                <div className="nav-item-wrapper">
                                    <Link
                                        className={`nav-link label-1 ${location.pathname === '/packages' ? 'active' : ''}`}
                                        to="/packages"
                                        role="button"
                                        data-bs-toggle=""
                                        aria-expanded="false"
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="nav-link-icon">
                                                <FiPackage />
                                            </span>
                                            <span className="nav-link-text-wrapper">
                                                <span className="nav-link-text">Packages</span>
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            </li>
                            
                        </ul>
                    </div>
                </div>
                <div className="navbar-vertical-footer">
                    <button 
                        className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
                        onClick={handleNavbarVerticalToggle}
                    >
                        <span className="uil uil-left-arrow-to-left fs-8" />
                        <span className="uil uil-arrow-from-right fs-8" />
                        <span className="navbar-vertical-footer-text ms-2">Collapsed View</span>
                    </button>
                </div>
            </nav>
            <nav className="navbar navbar-top fixed-top navbar-expand" id="navbarDefault">
                <div className="collapse navbar-collapse justify-content-between">
                    <div className="navbar-logo">
                        <button
                            className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarVerticalCollapse"
                            aria-controls="navbarVerticalCollapse"
                            aria-expanded="false"
                            aria-label="Toggle Navigation"
                        >
                            <span className="navbar-toggle-icon">
                                <span className="toggle-line" />
                            </span>
                        </button>
                        <Link className="navbar-brand me-1 me-sm-3" to="/" />
                        <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center">
                                <img
                                    src="/assets/img/icons/logo.png"
                                    alt="fms-logo"
                                    width={27}
                                />
                                <h5 className="logo-text ms-2 d-none d-sm-block">FMS</h5>
                            </div>
                        </div>
                    </div>
                    <div
                        className="search-box navbar-top-search-box d-none d-lg-block"
                        data-list='{"valueNames":["title"]}'
                        style={{ maxWidth: "25rem" }}
                    >
                        <form
                            className="position-relative"
                            data-bs-toggle="search"
                            data-bs-display="static"
                        >
                            <input
                                className="form-control search-input fuzzy-search rounded-pill form-control-sm"
                                type="search"
                                placeholder="Search..."
                                aria-label="Search"
                            />
                            <span className="fas fa-search search-box-icon" />
                        </form>
                        <div
                            className="btn-close position-absolute end-0 top-50 translate-middle cursor-pointer shadow-none"
                            data-bs-dismiss="search"
                        >
                            <button className="btn btn-link p-0" aria-label="Close" />
                        </div>
                        <div className="dropdown-menu border start-0 py-0 overflow-hidden w-100">
                            <div className="scrollbar-overlay" style={{ maxHeight: "30rem" }}>
                                <div className="list pb-3">
                                    <hr className="my-0" />
                                    <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                                        Related Searches
                                    </h6>
                                    <div className="py-2">
                                        <Link
                                            className="dropdown-item"
                                            to="apps/e-commerce/landing/product-details.html"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="fw-normal text-body-highlight title">
                                                    <span
                                                        className="fa-brands fa-firefox-browser text-body"
                                                        data-fa-transform="shrink-2"
                                                    />{" "}
                                                    Search in the Web MacBook
                                                </div>
                                            </div>
                                        </Link>
                                        <Link
                                            className="dropdown-item"
                                            to="apps/e-commerce/landing/product-details.html"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="fw-normal text-body-highlight title">
                                                    {" "}
                                                    <span
                                                        className="fa-brands fa-chrome text-body"
                                                        data-fa-transform="shrink-2"
                                                    />
                                                    Store MacBook″
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <p className="fallback fw-bold fs-7 d-none">No Result Found.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="navbar-nav navbar-nav-icons flex-row">
                        {/* <li className="nav-item">
                            <div className="theme-control-toggle fa-icon-wait px-2">
                                <input
                                    className="form-check-input ms-0 theme-control-toggle-input"
                                    type="checkbox"
                                    data-theme-control="fmsTheme"
                                    defaultValue="dark"
                                    id="themeControlToggle"
                                />
                                <label
                                    className="mb-0 theme-control-toggle-label theme-control-toggle-light"
                                    htmlFor="themeControlToggle"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="left"
                                    data-bs-title="Switch theme"
                                    style={{ height: 32, width: 32 }}
                                >
                                    <span className="icon" data-feather="moon" />
                                </label>
                                <label
                                    className="mb-0 theme-control-toggle-label theme-control-toggle-dark"
                                    htmlFor="themeControlToggle"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="left"
                                    data-bs-title="Switch theme"
                                    style={{ height: 32, width: 32 }}
                                >
                                    <span className="icon" data-feather="sun" />
                                </label>
                            </div>
                        </li> */}
                        <li className="nav-item d-lg-none">
                            <Link
                                className="nav-link"
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#searchBoxModal"
                            >
                                <span className="d-block" style={{ height: 20, width: 20 }}>
                                    <span
                                        data-feather="search"
                                        style={{ height: 19, width: 19, marginBottom: 2 }}
                                    />
                                </span>
                            </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link
                                className="nav-link"
                                to="#"
                                style={{ minWidth: "2.25rem" }}
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                data-bs-auto-close="outside"
                            >
                                <span className="d-block" style={{ height: 20, width: 20 }}>
                                    <span data-feather="bell" style={{ height: 20, width: 20 }} ></span>
                                </span>
                            </Link>
                            <div
                                className="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow border navbar-dropdown-caret"
                                id="navbarDropdownNotfication"
                                aria-labelledby="navbarDropdownNotfication"
                            >
                                <div className="card position-relative border-0">
                                    <div className="card-header p-2">
                                        <div className="d-flex justify-content-between">
                                            <h5 className="text-body-emphasis mb-0">Notifications</h5>
                                            <button
                                                className="btn btn-link p-0 fs-9 fw-normal"
                                                type="button"
                                            >
                                                Mark all as read
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body p-0">
                                        <div
                                            className="scrollbar-overlay"
                                            style={{ height: "27rem" }}
                                        ></div>
                                    </div>
                                    <div className="card-footer p-0 border-top border-translucent border-0">
                                        <div className="my-2 text-center fw-bold fs-10 text-body-tertiary text-opactity-85">
                                            <Link className="fw-bolder" to="pages/notifications.html">
                                                Notification history
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        {/* <li class="nav-item dropdown">
          <Link class="nav-link" id="navbarDropdownNindeDots" to="#" role="button" data-bs-toggle="dropdown"
              aria-haspopup="true" data-bs-auto-close="outside" aria-expanded="false"><svg width="16" height="16"
                  viewbox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
                  <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
                  <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
                  <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
                  <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
                  <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
                  <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
                  <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
                  <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
              </svg></Link>
          <div class="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-nine-dots shadow border"
              aria-labelledby="navbarDropdownNindeDots">
              <div class="card bg-body-emphasis position-relative border-0">
                  <div class="card-body pt-3 px-3 pb-0 overflow-auto scrollbar" style="height: 20rem;">
                      <div class="row text-center align-items-center gx-0 gy-0">
                          <div class="col-4"><a
                                  class="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                                  to="#!"><img src="/assets/img/team/57.webp" alt="" width="30" />
                                  <p class="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">Behance
                                  </p>
                              </Link></div>
                          <div class="col-4"><a
                                  class="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                                  to="#!"><img src="/assets/img/team/57.webp" alt="" width="30" />
                                  <p class="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">Cloud
                                  </p>
                              </Link></div>
                          <div class="col-4"><a
                                  class="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                                  to="#!"><img src="/assets/img/team/57.webp" alt="" width="30" />
                                  <p class="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">Slack
                                  </p>
                              </Link></div>

                      </div>
                  </div>
              </div>
          </div>
      </li> */}
                        <li className="nav-item dropdown">
                            <Link
                                className="nav-link lh-1 pe-0"
                                id="navbarDropdownUser"
                                to="#!"
                                role="button"
                                data-bs-toggle="dropdown"
                                data-bs-auto-close="outside"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <div className="avatar avatar-l ">
                                    <img
                                        className="rounded-circle "
                                        src="/assets/img/team/male.jpg"
                                        alt=""
                                        width={40}
                                    />
                                </div>
                            </Link>
                            <div
                                className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border"
                                aria-labelledby="navbarDropdownUser"
                            >
                                <div className="card position-relative border-0">
                                    <div className="card-body p-0">
                                        <div className="text-center pt-4 pb-3">
                                            <div className="avatar avatar-xl ">
                                                <img
                                                    className="rounded-circle "
                                                    src="/assets/img/team/male.jpg"
                                                    alt=""
                                                    width={72}
                                                />
                                            </div>
                                            <h6 className="mt-2 text-body-emphasis">Mukan Singh</h6>
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto scrollbar"
                                        style={{ height: "5rem" }}
                                    >
                                        <ul className="nav d-flex flex-column mb-2 pb-1">
                                            <li className="nav-item">
                                                <Link className="nav-link px-3 d-block" to="#!">
                                                    {" "}
                                                    <span
                                                        className="me-2 text-body align-bottom"
                                                        data-feather="user"
                                                    />
                                                    <span>Profile</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link px-3 d-block" to="#!">
                                                    {" "}
                                                    <span
                                                        className="me-2 text-body align-bottom"
                                                        data-feather="settings"
                                                    />
                                                    Settings &amp; Privacy{" "}
                                                </Link>
                                            </li>
                                            {/* <li class="nav-item"><Link class="nav-link px-3 d-block" to="#!"> <span
                                      class="me-2 text-body align-bottom" data-feather="help-circle"></span>Help
                                  Center</Link></li> */}
                                            {/* <li class="nav-item"><Link class="nav-link px-3 d-block" to="#!"> <span
                                      class="me-2 text-body align-bottom" data-feather="globe"></span>Language</Link>
                          </li> */}
                                        </ul>
                                    </div>
                                    <div className="card-footer p-0 border-top border-translucent">
                                        <ul className="nav d-flex flex-column my-3">
                                            <li className="nav-item">
                                                <Link className="nav-link px-3 d-block" to="#!">
                                                    {" "}
                                                    <span
                                                        className="me-2 text-body align-bottom"
                                                        data-feather="user-plus"
                                                    />
                                                    Add another account
                                                </Link>
                                            </li>
                                        </ul>
                                        <hr />
                                        <div className="px-3">
                                            {" "}
                                            <Link to="/logout" className="btn btn-phoenix-secondary d-flex flex-center w-100">
  <span data-feather="log-out" className="me-2" />
  Sign out
</Link>
                                        </div>
                                        <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
                                            <Link className="text-body-quaternary me-1" to="#!">
                                                Privacy policy
                                            </Link>
                                            •
                                            <Link className="text-body-quaternary mx-1" to="#!">
                                                Terms
                                            </Link>
                                            •
                                            <Link className="text-body-quaternary ms-1" to="#!">
                                                Cookies
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    );
};

export default Header;
